// frame: loTcH @ ui/dogdisk-agent.pen (登录历史 整页 1440×900)
// spec: docs/ui/agent-page-flows.md §yDAqU sec1 row3 + §pen-to-code-backlog.md §3.4 B5 loTcH
//
// 复用 B7 已落地的 /gapi/list_my_login_history endpoint(handler 已实装,但底层表
// `login_history` 可能未 migration → handler 返空 list)。
//
// 当 backend 表上线时此页**无需改代码**;若 endpoint 5xx 则前端展示 fallback 提示。
import { History, AlertCircle, Shield } from 'lucide-react'
import { Spinner, formatDate } from '@dogdisk/shared'
import { AgentLayout } from '../components/agent-layout'
import { useMyLoginHistory } from '../_lib/agent-api'

export function AgentLoginHistoryPage() {
  // TODO(api): backend login_history 表未 migration(B7 范围) — endpoint 当前返空 list,
  //            上线后此 hook 自动渲染真数据,无需改前端。
  const { data, isLoading, error } = useMyLoginHistory(50)
  const rows = data?.history ?? []

  return (
    <AgentLayout topbarTitle="代理 · 登录历史">
      <div className="mx-auto flex w-[920px] flex-col gap-4 px-6 py-8" data-testid="loTcH">
        <header className="flex items-center gap-3">
          <History size={22} className="text-amber-500" />
          <div>
            <h1 className="text-xl font-bold text-gray-900">登录历史</h1>
            <p className="text-sm text-gray-500">最近 50 条登录尝试(含失败) · 异常登录可在此自查</p>
          </div>
        </header>

        <section className="rounded-xl border border-gray-200 bg-white shadow-sm">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <Spinner className="text-amber-500" />
            </div>
          ) : error ? (
            <div className="flex items-start gap-3 px-6 py-8 text-sm text-amber-700">
              <AlertCircle size={18} className="mt-0.5 shrink-0" />
              <div>
                <p className="font-medium">登录历史暂不可用</p>
                <p className="mt-1 text-xs text-amber-600">
                  TODO(api): backend `login_history` 表 / `list_my_login_history` RPC 待 B7 落地。
                </p>
              </div>
            </div>
          ) : rows.length === 0 ? (
            <p className="px-6 py-12 text-center text-sm text-gray-400">暂无登录记录</p>
          ) : (
            <table className="w-full border-collapse text-sm">
              <thead className="border-b border-gray-200 bg-gray-50 text-xs uppercase text-gray-500">
                <tr>
                  <th className="px-4 py-3 text-left font-medium">时间</th>
                  <th className="px-4 py-3 text-left font-medium">IP</th>
                  <th className="px-4 py-3 text-left font-medium">User-Agent</th>
                  <th className="px-4 py-3 text-right font-medium">结果</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr
                    key={row.id}
                    className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50"
                    data-testid={`login-row-${row.id}`}
                  >
                    <td className="px-4 py-3 text-gray-700">{formatDate(row.created_at)}</td>
                    <td className="px-4 py-3 font-mono text-xs text-gray-600">{row.ip ?? '—'}</td>
                    <td className="max-w-[420px] truncate px-4 py-3 text-xs text-gray-500">
                      {row.ua ?? '—'}
                    </td>
                    <td className="px-4 py-3 text-right">
                      {row.success ? (
                        <span className="inline-flex items-center gap-1 rounded bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">
                          <Shield size={12} />
                          成功
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 rounded bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700">
                          失败 {row.failure_reason ? `· ${row.failure_reason}` : ''}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      </div>
    </AgentLayout>
  )
}
